module.exports = __webpack_public_path__ + "img/article.ce5a3a1f.svg";